import { render, staticRenderFns } from "./CreatePersonView.vue?vue&type=template&id=d66029dc&scoped=true&"
import script from "./CreatePersonView.vue?vue&type=script&lang=ts&"
export * from "./CreatePersonView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66029dc",
  null
  
)

export default component.exports